import { Tag } from "../../primitives";

export const OptionBadge = ({ badge }: { badge: string }) => (
	<Tag color="blue" className="font-mono font-bold tabular-nums text-primary" testId="option-badge">
		{badge}
	</Tag>
);
